
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="赛季赛区">
<!--              <a-cascader :options="sjsqOptions" :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛季赛区" v-model="queryParam.sjsq" changeOnSelect-->
<!--              />-->
              <a-cascader :show-search="{ sjsqFilter }" :options="sjsqOptions" :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区" v-model="queryParam.sjsq" changeOnSelect />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="授权编号">
                <a-input v-model="queryParam.kaojiregist_code" placeholder="搜索授权编号"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="单位名称">
                <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="考试时间">
                <a-range-picker
                        v-model="time_range_moment"
                        style="width: 100%"
                        format="YYYY-MM-DD HH:mm:ss"
                        :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
                />
              </a-form-item>
            </a-col>

          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >


    </div>

    <s-table
            ref="table"
            size="default"
            :columns="columns"
            :data="loadData"
            :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="title1" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.title}}
            <!--<br/><span style="color: #999">{{record.mingcheng}}</span>-->
            <br/>
            {{record.create_time|timeFormat}}
            <br/>
          </div>
      </span>
      <span slot="saiqu" slot-scope="text,record">
        {{record.saiqu_name}}
      </span>
      <span slot="status" slot-scope="text,record">
         {{record.current_index+1}}/{{record.duiwu_count}}
      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleDetail(record)">评分页</a>
          <a-divider type="vertical"/>
          <a @click="handleDownload(record)">导出场次成绩</a>
        </template>
      </span>
    </s-table>


  </a-card>
</template>

<style scoped>

  .ant-transfer .ant-transfer-list:first-child .footer-btn{display: none}
  .subject-transfer  /deep/ .is-visible {
    height: auto !important;
  }

</style>
<script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import areaOptions from '@/utils/area'
  import moment from 'moment'
  import setting from '@/config/setting'
  import UserPicker from '@/components/UserPicker/'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import { startListOptions ,getStartRunList,startListSave ,getScoreUserList,addScoreUser,deleteScoreUser ,setStatus ,startListDelete} from '@/api/dscore'
  import {sjsqOptions} from '@/api/sai'
  export default {
    name: 'ScoreRun',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      EditableCell,
      UserPicker
    },
    data () {
      return {
        areaOptions,
        sjsqOptions:[],
        visible: false,
        saveLoading:false,
        saiqu:0,
        mingdanList:[
        ],
        mingdanTargetKeys:[],
        selectedMingdanKeys:[],
        scoreUserList:[],

        userVisible: false,

        userFormData: {
          user_id: undefined,
          type: undefined,
          name: undefined,
          start_id: 0
        },

        formData:{
          id:0,
        },
        time_range_moment:[],
        time_range:[],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
//          xs: { span: 24 },
//          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
          status:2
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '场次信息',
            dataIndex: 'title',
            scopedSlots: { customRender: 'title1' },
          },
          {
            title: '赛区',
            dataIndex: 'saiqu',
            scopedSlots: { customRender: 'saiqu' +
            '' },
          },
          {
            title: '进度',
            dataIndex: 'status',
            scopedSlots: { customRender: 'status' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 250,
            scopedSlots: { customRender: 'action' },
          }
        ],



        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;

          if (this.time_range_moment[0] && this.time_range_moment[1]) {
            this.queryParam.time_range = [
              this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
              this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
            ]
          } else {
            this.queryParam.time_range = []
          }

          this.queryParam = Object.assign(this.queryParam,parameter);
          return getStartRunList(this.queryParam)
                  .then(res => {
                    console.log('res');
                    return res.data
                  })
        },

        selectedRowKeys: [],
        selectedRows: [],
      }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
      that.getSjsqOptions();
    },
    methods: {
      moment,
      getSjsqOptions(){
        let that = this;
        sjsqOptions({}).then(res =>{
          that.sjsqOptions = res.data;
        });
      },
      handleCancel(){
        this.visible = false
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      handleDetail(record){
        let self = this
        window.open('scoreForm?id='+record.id);
      },

      handleDownload(record) {
          window.open(setting.apiBaseURL + '/adminapi/dscore/startListDownload?id=' + record.id);
      },


      // 查
      onSearch() {
        let self = this;
        self.$refs.table.refresh(false)
      },


      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      sjsqFilter(inputValue, path) {
        return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
      },
    },
    filters:{
    },
    watch: {
    }
  }
</script>
